import React, {useContext, useId} from 'react';
import classNames from 'classnames';
import {Tooltip as MuiTooltip, TooltipProps} from '@mui/material';

import {PathDesignContext} from './path-design-context';

import styles from './tooltip.module.scss';

interface Props {
  className?: string;
}

const Tooltip = ({className, children, ...remainingProps}: Props & TooltipProps) => {
  const descriptionId = useId();
  const path = useContext(PathDesignContext);

  return (
    <>
      <MuiTooltip
        classes={{
          arrow: classNames(styles.arrow, {[styles.path]: path.enabled}),
          tooltip: classNames(styles.tooltip, className, {[styles.path]: path.enabled}),
        }}
        arrow
        {...remainingProps}
        enterTouchDelay={100}
        aria-label={undefined}
        aria-describedby={descriptionId}
      >
        {children}
      </MuiTooltip>
      <span id={descriptionId} className="sr-only">
        {remainingProps.title}
      </span>
    </>
  );
};

export default Tooltip;
